import { Dialog, DialogActions, DialogContent, DialogTitle, Fade } from '@mui/material';
import { CustomButton } from '../customButton/CustomButton';

import './customDialog.scss';
export const CustomDialog = ({
    open = false,
    fullWidth = false,
    maxWidth,
    title = '',
    dialogTitle = null,
    children,
    onCancel,
    onAccept,
    cancelText = 'Cancelar',
    acceptText = 'Aceptar',
    acceptLoading = false,
    cancelLoading = false,
    acceptDisabled = false,
    cancelDisabled = false,
    customActions,
    customActionsDirection = 'end',
    onBackdropClick,
    sxDialogContent,
    boldDialogTitle,
    ...props
}) => {

    const onClose = (event, reason) => {
        if (reason === 'backdropClick' && onBackdropClick) {
            onBackdropClick();
        } else {
            onCancel?.()
        }
    }
    return (
        <Dialog
            {...props}
            className='custom-dialog-container'
            open={open}
            fullWidth={fullWidth}
            maxWidth={maxWidth}
            onClose={onClose}
            keepMounted={false}
            TransitionComponent={Fade}
            transitionDuration={300}
            slotProps={{
                transition: {
                    appear: true,
                    unmountOnExit: true, // desmonta el contenido al cerrar
                }
            }}
        >
            {dialogTitle && (
                <DialogTitle sx={boldDialogTitle ? { fontWeight: 'bold' } : {}}>
                    {dialogTitle}
                </DialogTitle>
            )}
            <DialogContent className='custom-dialog' sx={sxDialogContent ? sxDialogContent : null}>
                {title && (

                    <h3 className='dialog-title'>
                        {title}
                    </h3>
                )}
                {children}
            </DialogContent>
            <DialogActions className='dialog-actions'>
                {!!customActions && customActionsDirection === 'start' && customActions}
                {onCancel && (
                    <CustomButton
                        variant='outlined'
                        outlinedGray={true}
                        onClick={onCancel}
                        size='small'
                        isLoading={cancelLoading}
                        disabled={cancelDisabled}
                    >
                        {cancelText}
                    </CustomButton>
                )}
                {!!customActions && customActionsDirection === 'center' && customActions}
                {onAccept && (
                    <CustomButton
                        onClick={onAccept}
                        size='small'
                        isLoading={acceptLoading}
                        disabled={acceptDisabled}
                    >
                        {acceptText}
                    </CustomButton>
                )}
                {!!customActions && customActionsDirection === 'end' && customActions}
            </DialogActions>
        </Dialog>
    )
}